// LIDUsageDialog.jsx
import { Button } from '@mui/material'

export default function LIDUsageDialog({setFullModel, model, setModel, target, subcatchment}) {
  
  const saveEdits = () => {
    //let cleanSub = JSON.parse(JSON.stringify(model))
    setFullModel(prev => ({
      ...prev,
      LID_USAGE:{
        ...prev.LID_USAGE,
        [subcatchment]: model.LID_USAGE[subcatchment]
      }
    }))
  }

  const updateValue = (val, type) => {
    if(model && model.LID_USAGE){
      // Copy the object at the target position.
      let thisObj = JSON.parse(JSON.stringify(model.LID_USAGE[subcatchment]))
      // Update the value.
      thisObj[target][type] = val
      // Replace the object at the target position.
      setModel(prev => ({
        ...prev,
        LID_USAGE:{
          ...prev.LID_USAGE,
          [subcatchment]: thisObj
        }
      }))
    }
  }

  if(model){
    return(
      <>
      {
        <>
          {(
            <>
              <div>LID Usage Dialog {target} for {subcatchment} </div>
              <div>
                <Button fullWidth onClick={saveEdits} >Save Edits</Button>
              </div>
              <label className='editor-small' >LID Control Name
                <input  type = "text"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'Name')}}
                        value={model.LID_USAGE[subcatchment][target].Name}
                        id={'Name_'+target}
                />
              </label>
              <label className='editor-small' >Area of Each Unit (sq ft or sq m)
                <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'Area')}}
                        value={model.LID_USAGE[subcatchment][target].Area}
                        id={'Area_'+target}
                />
              </label>
              <label className='editor-small' >Number of units
                <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'Number')}}
                        value={model.LID_USAGE[subcatchment][target].Number}
                        id={'Number_'+target}
                />
              </label>
              <label className='editor-small' >Surface Width per Unit (ft or m)
                <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'Width')}}
                        value={model.LID_USAGE[subcatchment][target].Width}
                        id={'Width_'+target}
                />
              </label>
              <label className='editor-small' >% Initially Saturated
                <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'InitSat')}}
                        value={model.LID_USAGE[subcatchment][target].InitSat}
                        id={'InitSat_'+target}
                />
              </label>
              <label className='editor-small' >% of Impervious Area Treated
                <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'FromImp')}}
                        value={model.LID_USAGE[subcatchment][target].FromImp}
                        id={'FromImp_'+target}
                />
              </label>
              <label className='editor-small' >% of Pervious Area Treated
                <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'FromPerv')}}
                        value={model.LID_USAGE[subcatchment][target].FromPerv}
                        id={'FromPerv_'+target}
                />
              </label>
              <label className='editor-small' >Send Drain Flow To:
                <input  type = "text"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'DrainTo')}}
                        value={model.LID_USAGE[subcatchment][target].DrainTo}
                        id={'DrainTo_'+target}
                />
              </label>
              <label className='editor-small' >Detailed Report File
                <input  type = "text"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'RptFile')}}
                        value={model.LID_USAGE[subcatchment][target].RptFile}
                        id={'RptFile_'+target}
                />
              </label>
              <label className='editor-small' >
                <input  type = "checkbox"
                        style={{display: 'inline'}}
                        onChange={(e)=>{updateValue(e.target.checked?1:0, 'ToPerv')}}
                        checked={model.LID_USAGE[subcatchment][target].ToPerv!==0}
                        id={'ToPerv_'+target}
                />Return All Outflow to Perv. Area
              </label>
            </>
          )}
        </>
      }
      </>
    )
  } else {
    return (null)
  }
}